export default "__VITE_ASSET__B$IRWjgZ__"